import { SVGProps } from 'react'

import { wrapIcon } from '../wrap-icon'

function SvgItalic(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M15 20H7v-2h2.927l2.116-12H9V4h8v2h-2.927l-2.116 12H15v2Z" fill="currentColor" />
    </svg>
  )
}
export default wrapIcon(SvgItalic)
